import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import authStore from '../../auth/auth-store'
import setStatementQuery from './set-statement-query'
import { IUser } from '../../../model/user'
import feedStore from '../../feed/feed-store'

export default async function toggleCreatedByUser(context: BareActionContext<StatementState, RootState>)
{
    const form = statementStore.state.statementSearchForm
    form.createdByFollowing = false
    form.createdByMe = false
    console.log('searchUser: %j', feedStore.state.feedUser)
    console.log('authhUser: %j', authStore.state.user)
    form.jybedByUser = !form.createdByUser

    setStatementQuery(context)

    return
}
